import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useAuth } from '../../context/AuthContext';

function Footer() {
  const { loggedIn } = useAuth();

  if (!loggedIn) return null;

  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 3,
        mt: 'auto',
        backgroundColor: '#fff',
        borderTop: '1px solid #e0e0e0',
      }}
    >
      <Typography color="text.secondary" align="center" sx={{ fontSize: '0.6rem', mt: 1 }}>
        Rentabilidades pasadas no garantizan rentabilidades futuras.
      </Typography>
          <Box
            component="footer"
            sx={{
              maxWidth: '800px',
              margin: '0 auto',
            }}
          >
        <Typography color="text.secondary" align="center" sx={{ fontSize: '0.6rem', mt: 1 }}>
          Las oportunidades de inversión ofrecidas no constituyen una actividad de financiación participativa regulada conforme al Reglamento (UE) 2020/1503 y no está sujeta a autorización ni supervisión por la CNMV. Ondara Capital, S.L. (B67229757) y Vern Properties, S.L. (B02980639) son empresas del Grupo Ondara. Ondara Capital, S.L. es una sociedad, regulada, supervisada y registrada en el Banco de España con el código de Entidad D552.
        </Typography>
      </Box>
      <Typography color="text.secondary" align="center" sx={{ fontSize: '0.6rem', mt: 1 }}>
        We Make Sure. © {new Date().getFullYear()} Ondara.
      </Typography>
    </Box>
  );
};

export default Footer;